// Recursive's real slant, for the project cards' footnotes. It's the mono face at `slnt` -15
// with only `wght` varying (`MONO` 1, `CASL` 0, and the slant are baked into the file), which
// makes it 45 KB instead of 214 KB with every axis.
//
// The face claims `15deg` and nothing else. A range starting at `0deg` would match upright
// text too, and the page would draw everything with this file.
//
// A script adds it after the page shows, because as a stylesheet face the browser fetched it
// ahead of the upright font that the page waits for. Until it loads, the footnotes get the
// upright face, slanted.

import obliqueUrl from "../assets/fonts/recursive-mono-oblique.woff2?url";

export function addObliqueFace(): void {
  const face = new FontFace("Recursive", `url(${obliqueUrl}) format("woff2")`, {
    style: "oblique 15deg",
    weight: "300 1000",
    display: "swap",
  });
  document.fonts.add(face);
  face.load().catch((error: unknown) => console.warn("The slanted face did not load", error));
}
